/**
 * Contains some pre-baked styles.
 */

export const flexRow = {
  display: 'flex',
  flexDirection: 'row'
}

export const flexColumn = {
  display: 'flex',
  flexDirection: 'column'
}
